<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="chevron-right">
<path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M7.79635 20.8538C7.60109 20.6585 7.60109 20.342 7.79635 20.1467L15.9428 12.0002L7.79635 3.8538C7.60109 3.65854 7.60109 3.34195 7.79635 3.14669C7.99161 2.95143 8.3082 2.95143 8.50346 3.14669L17.0035 11.6467C17.1987 11.842 17.1987 12.1585 17.0035 12.3538L8.50346 20.8538C8.30819 21.0491 7.99161 21.0491 7.79635 20.8538Z" fill="#212328"/>
</g>
</svg>
